// src/components/ProtectedRoute.tsx
import { Navigate, useLocation } from 'react-router-dom';
import { useGetLoggedInUserData } from '@/services/auth/auth';
import { Center } from '@chakra-ui/react';
import { NAVIGATION_ROUTES } from '@/routes/constants';
import LoadingComponent from '@/components/common/Loading';

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const { data: user, isLoading, error } = useGetLoggedInUserData();
  const location = useLocation();

  // While checking auth
  if (isLoading) {
    return (
      <Center height="100vh" bg="background.secondary">
        <LoadingComponent />
      </Center>
    );
  }

  // If not authenticated (no user + not loading)
  if (!user || error) {
    return <Navigate to={NAVIGATION_ROUTES.SIGNIN} state={{ from: location }} replace />;
  }

  // Authenticated → render children
  return children;
};

export default ProtectedRoute;
